import {ChangeDetectorRef, Component, forwardRef, Inject, ViewChild} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, Searchbar} from 'ionic-angular';
import {EbsWebService} from "../../services/ebsWebService";
import {EbsComponentService} from "../../services/ebsComponentService";
import { EbsWebServiceGlobals } from '../../services/ebsWebServiceGlobals';
import {Detail} from "../detail/detail";
declare var $;

@IonicPage()
@Component({
  selector: 'page-grid-box',
  templateUrl: 'grid-box.html',
})
export class GridBoxPage {

  title: any;
  data: any;
  moreItemsAvailable:boolean = false;
  loadMoreURL:string = "";
  loadMoreParams:string = "";
  searchword:string = "";
  showSpinner:boolean = false;
  beforeSearchData: any;
  private showQRCODE = true;

  @ViewChild("searchbar") searchbar:Searchbar;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public platform: Platform,
              private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
              public ebsWebserviceGlobals: EbsWebServiceGlobals,
              public loadingCtrl: LoadingController,
              private cdRef:ChangeDetectorRef) {

    if(this.platform.is('core') || this.platform.is('mobileweb')){
      this.showQRCODE = false;
    }


    if (typeof this.navParams.get("searchresult") != "undefined" && this.navParams.get("searchresult") != null) {
      this.data = this.navParams.get("searchresult");
      this.beforeSearchData = this.data;
      this._ebsWebService.setBrowserTabTitle(this.data.MainTitle);
      this.title = this.data.Caption;

    } else {
      if (typeof this.navParams.get('actionURL') != "undefined") {
        let loading = this.loadingCtrl.create({
          content: 'Bitte warten...'
        });
        loading.present();
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
        this._ebsWebService.postData(navParams.get('actionURL'),postPayloadObject).subscribe(res => {
          if (typeof res != "undefined" && res != null) {
            if (res.ViewType == "Detail") {
              loading.dismiss();
              this.navCtrl.push(Detail, {
                title: res.ListItemNavigation[0].ActionCaption,
                actionURL: res.ListItemNavigation[0].Action,
                postParams: res.ListItemNavigation[0].PostParameters
              });
            } else {
              this.data = res;
              this.beforeSearchData = this.data;
              this.title = res.MainTitle;
              this._ebsWebService.setBrowserTabTitle(res.MainTitle);
              this.cdRef.detectChanges();
              loading.dismiss();
            }
          }
        });
      }
    }
  }

  checkForPaging() {
    this.loadMoreURL = "";
    if (this.data.ListItemAction != null) {
      this.data.ListItemAction.forEach(element => {
        if(element.ActionName === "Paging") {
          this.loadMoreURL = element.ActionUrl;
          this.loadMoreParams = element.PostParameters;
          this.moreItemsAvailable = true;
        } else {
          this.moreItemsAvailable = false;
        }
      });
    } else {
      this.moreItemsAvailable = false;
    }
  }

  ionViewDidLoad() {
    setTimeout(() => {
      if (typeof this.searchbar != "undefined" && !this.platform.is("tablet") ) {
        this.searchbar.setFocus();
      }
    }, 1000);
  }

  loadMore(event){
    this.checkForPaging();
    setTimeout(() => {
      if (this.loadMoreURL != "") {
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.loadMoreParams);
        this._ebsWebService.postData(this.loadMoreURL,postPayloadObject).subscribe(res => {
          this.data.ListItemNavigation = this.data.ListItemNavigation.concat(res.ListItemNavigation);
        });
      }
      event.complete();
    }, 500);
  }

  loadMoreOnClick(loadMoreURL,postParams){
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(postParams);
    this._ebsWebService.postData(loadMoreURL,postPayloadObject).subscribe(res => {
      this.data.ListItemNavigation = this.data.ListItemNavigation.concat(res.ListItemNavigation);
    });
  }

  onSearchInput(){
    if (this.searchword.length>1) {
      this.showSpinner = true;

      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.data.SearchUrlPostParameters + this.searchword);
      this._ebsWebService.postData(this.data.SearchUrl,postPayloadObject).subscribe(res=>{
        this.showSpinner = false;
        if (res.ViewType == "Detail") {
          this.navCtrl.push(Detail, {
            title: res.ListItemNavigation[0].ActionCaption,
            actionURL: res.ListItemNavigation[0].Action,
            postParams: res.ListItemNavigation[0].PostParameters
          });
        } else {
          this.data = res;
        }
      });

      setTimeout(function(){
        this.showSpinner = false;
      }, 10000)
    } else {
      this.data = this.beforeSearchData;
    }
  }

  onSearchClear(){
    this.searchword="";
    this.data = this.beforeSearchData;
  }


}



// WEBPACK FOOTER //
// ./src/pages/grid-box/grid-box.ts